import React from "react";

export default function TitleBar(props) {
    return (
        
        < div className="row" >

            <div className="col">
                <h5>{props.propertyName}</h5>
            </div>
            <div className="col">
                <div className="float-right">
                    <a href={props.propertyWebsite}>back to website</a>
                </div>
            </div>
            
        </div>
    
    );
}